import CryptoJS from "crypto-js";

/**
 * AES-128-ECB 加密
 * @param {string} data 待加密数据
 * @param {string} key 密钥（需为16字节）
 * @returns {string} Base64编码的密文
 */
export function encryptAES128ECB(data, key) {
    // 确保密钥是16字节（AES-128要求）
    const keyBytes = CryptoJS.enc.Utf8.parse(key);

    // 加密配置：ECB模式 + PKCS7填充
    const encrypted = CryptoJS.AES.encrypt(data, keyBytes, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });

    // 返回Base64格式密文
    return encrypted.toString();
}